/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as RecommendationsRouteImport } from './routes/recommendations'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnalysisSessionIdRouteImport } from './routes/analysis/$sessionId'

const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationsRoute = RecommendationsRouteImport.update({
  id: '/recommendations',
  path: '/recommendations',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysisSessionIdRoute = AnalysisSessionIdRouteImport.update({
  id: '/analysis/$sessionId',
  path: '/analysis/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/profile': typeof ProfileRoute
  '/recommendations': typeof RecommendationsRoute
  '/results': typeof ResultsRoute
  '/analysis/$sessionId': typeof AnalysisSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/profile': typeof ProfileRoute
  '/recommendations': typeof RecommendationsRoute
  '/results': typeof ResultsRoute
  '/analysis/$sessionId': typeof AnalysisSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/profile': typeof ProfileRoute
  '/recommendations': typeof RecommendationsRoute
  '/results': typeof ResultsRoute
  '/analysis/$sessionId': typeof AnalysisSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/profile'
    | '/recommendations'
    | '/results'
    | '/analysis/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/profile'
    | '/recommendations'
    | '/results'
    | '/analysis/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/profile'
    | '/recommendations'
    | '/results'
    | '/analysis/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRoute
  ProfileRoute: typeof ProfileRoute
  RecommendationsRoute: typeof RecommendationsRoute
  ResultsRoute: typeof ResultsRoute
  AnalysisSessionIdRoute: typeof AnalysisSessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendations': {
      id: '/recommendations'
      path: '/recommendations'
      fullPath: '/recommendations'
      preLoaderRoute: typeof RecommendationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analysis/$sessionId': {
      id: '/analysis/$sessionId'
      path: '/analysis/$sessionId'
      fullPath: '/analysis/$sessionId'
      preLoaderRoute: typeof AnalysisSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRoute,
  ProfileRoute: ProfileRoute,
  RecommendationsRoute: RecommendationsRoute,
  ResultsRoute: ResultsRoute,
  AnalysisSessionIdRoute: AnalysisSessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
